import { send } from 'server';

export const verifyNow = ({ successUrl, errorUrl, documentType }) => send({
    ID: 35688,
    description: 'Initiate document upload request',
    responses: [35689, 35690],
    service: 'netverify',
    successUrl,
    errorUrl,
    ...documentType && { documentType }
});

export const getPlayerRegulationStatuses = () => send({
    ID: 35691,
    historyLength: 'current',
    responses: [35692, 35693],
    description: 'Get player regulation statuses'
});
